<template>
  <v-expansion-panel class="idcs-main-back">
    <v-expansion-panel-header v-slot="{ open }">
      <v-layout align-center wrap>
        <v-flex xs12 sm6 md3 lg2 xl2>
          <v-subheader>
            <v-icon class="mr-2 all-ok-icon-color">fa-address-card</v-icon>
            {{ $t("card.data") }}
          </v-subheader>
        </v-flex>
        <v-flex xs12 sm6 md9 lg10 xl10>
          <div v-if="!open">
            <v-icon class>fa-user</v-icon>
            <v-icon small class="mx-6">fa-arrow-right</v-icon>
            <span v-if="cardDataTitle" class="title idcs-word-break">{{ cardDataTitle }}</span>
            <v-btn v-else text dark color="blue" @click="showEditor">
              {{ $t("card.add_user_data") }}
              <v-icon class="ml-2">mdi-pencil</v-icon>
            </v-btn>
            <v-icon class="ml-10">{{ card.pin ? "mdi-lock" : "mdi-lock-open-variant" }}</v-icon>
            <v-btn
              v-show="$store.getters.test('fcopy.t')"
              class="ml-2"
              icon
              color="blue"
              @click.stop="d_copy=true"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-simple-table>
        <thead>
          <tr>
            <th class="idcs-th-back text-center"></th>
            <template v-for="k in cardData">
              <th class="idcs-th-back" :key="k">{{ $t("card.prof." + k) }}</th>
            </template>
            <th class="idcs-th-back"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="idcs-th-back">
              <v-icon class>fa-user</v-icon>
            </td>
            <td class="idcs-data-back" v-for="k in cardData" :key="k">{{ card[k] }}</td>
            <td class="idcs-data-back" align="right">
              <v-btn
                x-small
                text
                color="blue"
                dark
                @click="showEditor"
                v-if="$store.getters.test('CardRecord.w')"
              >
                <div>{{ $t("button.edit") }}</div>
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                v-if="$store.getters.test('fpin.r')"
                icon
                dark
                color="blue"
                @click="d_pin=true"
              >
                <v-icon class="ml-2">{{ card.pin ? "mdi-lock" : "mdi-lock-open-variant" }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-expansion-panel-content>
    <v-dialog persistent v-model="d_pin" width="340">
      <v-card class="idcs-dialog-back">
        <v-card-title>
          <span>{{ $t("title.card_pin") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="(d_pin = false), (newPin = card.pin)">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            class="mt-5"
            v-model="newPin"
            clearable
            background-color="yellow lighten-5"
            color="black"
            outlined
            shaped
            counter="8"
            :placeholder="String(card.pin)"
            :label="$t('field.pin')"
            :rules="pin_rules"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="updatePin">{{ $t("button.ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="d_edit" transition="scroll-y-transition" persistent max-width="1200px">
      <Component
        :is="editorComp"
        ref="edt"
        :record="card"
        v-model="d_edit"
        @update="onUpdateRecord"
        @insert="onInsertRecord"
        @delete="onDeleteRecord"
      ></Component>
    </v-dialog>
    <v-dialog v-model="d_copy" transition="scroll-y-transition" persistent>
      <v-card class="idcs-dialog-back">
        <v-card-title>
          <span>{{ $t("title.card_copy") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="d_copy=false">
            <v-icon>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-divider></v-divider>
          <v-row align="center">
            <v-col cols="2"></v-col>
            <v-col cols="5" class="subtitle-2"><span class="mr-2">{{$t('card.field.sourceCard')}}</span><span>{{card.id}}</span></v-col>
            <v-col cols="5">
              <v-row align="center">
                <v-col cols="1">
                  <v-btn icon @click="clearCard2copy">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="11">
                  <v-form ref="c2c">
                    <v-text-field
                      v-model="card2copy.id"
                      :disabled="card2copy.blocked"
                      append-icon="mdi-magnify"
                      :label="$t('card.field.card2copy')"
                      :rules="[v=>!v || /^\d+$/gi.test(v) || $t('error.digits')]"
                      @click:append.stop="getCard2copy"
                      @click:clear="clearCard2copy"
                    ></v-text-field>
                  </v-form>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center">
            <template v-for="k in cardData">
              <v-col :key="k" cols="2" class="subheader-2">{{$t('card.prof.'+k)}}</v-col>
              <v-col :key="k+'1'" cols="5" align-self="stretch" class="yellow lighten-5 subheader-2">{{card[k]}}</v-col>
              <v-col :key="k+'2'" cols="5" align-self="stretch" class="orange lighten-5 subheader-2">{{card2copy[k]}}</v-col>
            </template>
          </v-row>
          <v-divider></v-divider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue"
            text
            :disabled="card2copy.id!=card2copy.baseid"
            @click.stop="copyCardData"
          >{{ $t("button.ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-expansion-panel>
</template>

<script>
import app from "@/app.js";
import * as components from "@/components/editTypes/card_editors.js";

export default {
  name: "cardProfilePanel",
  components: { ...components },
  props: {
    cardo: Object
  },
  data() {
    return {
      d_edit: false,
      d_pin: false,
      d_copy: false,
      pin_rules: [v => !v || /^\d{3,8}$/.test(v) || this.$t("error.pin")],
      newPin: null,
      card2copy: {
        id: "",
        baseid: "bad",
        first_name: "",
        second_name: "",
        company_name: "",
        company_subname: "",
        reg_num: "",
        additional: "",
        blocked: false
      },
      card: { ...this.cardo },
      editorComp: "CardRecord0",
      cardData: [
        "first_name",
        "second_name",
        "company_name",
        "company_subname",
        "reg_num",
        "additional"
      ]
    };
  },
  watch: {
    cardo: {
      handler(v) {
        this.card = { ...v };
      }
    }
  },
  computed: {
    cardDataTitle() {
      if (this.card.first_name || this.card.second_name) {
        return (
          (this.card.first_name ? this.card.first_name + " " : "") +
          (this.card.second_name ? this.card.second_name : "")
        );
      }
      if (this.card.company_name || this.card.company_subname) {
        return (
          (this.card.company_name ? this.card.company_name + " " : "") +
          (this.card.company_subname ? this.card.company_subname : "")
        );
      }
      if (this.card.additional || this.card.reg_num) {
        return (
          (this.card.additional ? this.card.additional + " " : "") +
          (this.card.reg_num ? this.card.reg_num : "")
        );
      }
      return "";
    }
  },
  methods: {
    clearCard2copy() {
      this.card2copy.id = "";
      this.card2copy.baseid = "bad";
      this.card2copy.first_name = "";
      this.card2copy.second_name = "";
      this.card2copy.company_name = "";
      this.card2copy.company_subname = "";
      this.card2copy.reg_num = "";
      this.card2copy.additional = "";
      this.card2copy.blocked = false;
    },
    getCard2copy() {
      if (!this.$refs.c2c.validate()) return;
      app
        .select(this.card2copy.id, "CardRecord")
        .then(response => {
          this.card2copy.baseid = response.id;
          this.card2copy.first_name = response.firstName;
          this.card2copy.second_name = response.secondName;
          this.card2copy.company_name = response.companyName;
          this.card2copy.company_subname = response.companySubName;
          this.card2copy.reg_num = response.regNumber;
          this.card2copy.additional = response.additional;
          this.card2copy.blocked = true;
        })
        .catch(error => {
          this.clearCard2copy();
          console.log(error);
        });
    },
    copyCardData() {
      app
        .cloneCardData(this.card.id, this.card2copy.id)
        .then(response => {
          let msg = this.$t("msg.clone.fail");
          if (response.count == 1) {
            msg = this.$t("msg.clone.ok");
          } else {
            this.clearCard2copy();
          }
          this.d_pin = false;
          this.$root.$emit("show_snack", {
            color: response.count == 1?"success":"error",
            msg: msg
          });
          this.d_copy=false;
        })
        .catch(() => {
          this.clearCard2copy();
          this.$root.$emit("show_snack", {
            color: false,
            msg: this.$t("msg.clone.fail")
          });
        });
    },
    showEditor() {
      this.editorComp = "CardRecord" + this.$store.getters.editor_type;
      this.d_edit = true;
    },
    updatePin() {
      app
        .updateCardPin(this.card.id, this.newPin)
        .then(response => {
          let msg = this.$t("msg.pin.fail");
          if (response.count == 1) {
            msg = this.$t("msg.pin.ok");
            this.card.pin = this.newPin;
          }
          this.d_pin = false;
          this.$root.$emit("show_snack", {
            color: response.count == 1,
            msg: msg
          });
        })
        .catch(() => {
          this.$root.$emit("show_snack", {
            color: false,
            msg: this.$t("msg.pin.fail")
          });
        });
    },
    onUpdateRecord() {
      this.$emit("cardUpdate");
    },
    onInsertRecord() {},
    onDeleteRecord() {}
  }
};
</script>

<style scoped>
.all-ok-icon-color {
  color: #81d4fa;
}
</style>